export default __webpack_public_path__ + "static/media/ic-close.648ba53f.svg";